import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const compactTestimonials = [{
  initial: 'N',
  name: 'Dr. Nicolás R.',
  role: 'R1, CABA',
  text: 'Me salvó en mi primera guardia nocturna. Seguridad inmediata.'
}, {
  initial: 'V',
  name: 'Dra. Valentina M.',
  role: 'R2, Córdoba',
  text: 'Los algoritmos de guardia son oro puro. Súper claros.'
}, {
  initial: 'S',
  name: 'Dr. Santiago L.',
  role: 'Guardia, Rosario',
  text: 'El criterio para pedir Rx me ahorró muchísimos problemas.'
}];
export function Hero() {
  return <section className="bg-gradient-to-b from-pastel-100 to-pastel-50 text-navy-900 pt-12 pb-16 px-4 relative overflow-hidden" data-id="element-88">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-pastel-200 rounded-full blur-3xl opacity-40 pointer-events-none" data-id="element-89"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-90">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-tight mb-8 text-navy-900 max-w-3xl mx-auto" data-id="element-91">
          El paciente empeoró. El médico tarda en llegar. Y tu cabeza se quedó
          en blanco.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-2xl mb-8" data-id="element-92">
          <a href="#compra" data-id="element-93">
            <img src="https://cdn.magicpatterns.com/uploads/wCfsTpYGA1bRgGPmwMyWfr/ChatGPT_Image_Jun_13__2026__07_13_01_PM-removebg-preview.png" alt="Enfermería Resuelta" className="w-full h-auto drop-shadow-2xl cursor-pointer" data-id="element-94" />
          </a>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-2xl font-medium text-navy-700 mb-8 max-w-3xl mx-auto" data-id="element-95">
          Para la enfermera que ya sabe lo que hace pero necesita una
          herramienta que funcione cuando el tiempo no alcanza.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-96">
          {['📄 100% PDF', '⚡ Acceso Inmediato', '📚 8 Capítulos + 2 Bonos'].map((badge, i) => <div key={i} className="bg-white border border-pastel-200 px-4 py-2 rounded-full text-sm md:text-base font-medium text-navy-800 shadow-sm" data-id="element-97">
              {badge}
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col items-center" data-id="element-98">
          <a href="#compra" className="inline-block w-full sm:w-auto px-8 py-4 bg-navy-800 hover:bg-navy-700 text-white font-bold text-lg md:text-xl rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1" data-id="element-99">
            Quiero llegar preparado a la guardia 🧠
          </a>

          <div className="mt-5 flex flex-col sm:flex-row items-center gap-4 text-navy-700 text-sm font-medium" data-id="element-100">
            <div className="flex items-center gap-1" data-id="element-101">
              <div className="flex text-gold-500" data-id="element-102">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-103" />)}
              </div>
              <span data-id="element-104">4.9/5 Calificación</span>
            </div>
          </div>

          {/* Compact testimonials below rating */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 w-full max-w-3xl" data-id="element-105">
            {compactTestimonials.map((t, i) => <div key={i} className="bg-white border border-pastel-200 rounded-xl p-4 text-left shadow-sm" data-id="element-106">
                <div className="flex text-gold-500 mb-2" data-id="element-107">
                  {[...Array(5)].map((_, j) => <Star key={j} size={12} fill="currentColor" data-id="element-108" />)}
                </div>
                <p className="text-navy-800 text-xs leading-snug mb-3 line-clamp-3" data-id="element-109">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-2 border-t border-pastel-100 pt-2" data-id="element-110">
                  <div className="w-7 h-7 bg-navy-800 rounded-full flex items-center justify-center text-white font-bold text-xs" data-id="element-111">
                    {t.initial}
                  </div>
                  <div className="min-w-0" data-id="element-112">
                    <p className="font-bold text-navy-900 text-xs truncate" data-id="element-113">
                      {t.name}
                    </p>
                    <p className="text-navy-600 text-[10px] truncate" data-id="element-114">
                      {t.role}
                    </p>
                  </div>
                </div>
              </div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}